function getDiscountObjectFromCode(discountCode: string, settings: any) {
  if (!settings?.discountCodes) return null;
  return settings.discountCodes.find((code: any) => code.code === discountCode);
}

export default getDiscountObjectFromCode;
